import React, { useEffect, useState, useContext } from "react";
import MainPageSlider from "../Components/MainPageSlider";
import { Container, Row, Col } from "react-bootstrap";
import GridTable from "../Components/GridTable";
import TopSelling from "../Components/TopSelling";
import NewArrival from "../Components/NewArrival";
import api from "../admin/api/api";
import { ShopContext } from "../context/ShopContext";


function MainPage() {
  
  const { shop } = useContext(ShopContext);
  const [topSelling, setTopSelling] = useState([]);
  const [discountProducts, setDiscountProducts] = useState([]);
  const [lowPriceProducts, setLowPriceProducts] = useState([]);
  const [newArrival, setNewArrival] = useState([]);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {

      const topSellingRes = await api.get("/public/products/topselling");
      const discountRes = await api.get("/public/products/discountproducts");
      const lowPriceRes = await api.get("/public/products/lowpriceproducts");
      const newArrivalRes = await api.get("/public/products/newarrival");

      setTopSelling(topSellingRes.data);
      setDiscountProducts(discountRes.data);
      setLowPriceProducts(lowPriceRes.data);
      setNewArrival(newArrivalRes.data);

    } catch (error) {
      console.error("Error loading products", error);
    }
  };

  return (
    <>
      
      <MainPageSlider />

      <Container fluid className="pt-4 pb-5" style={{ backgroundColor: "#f8f9fa" }}>
        <Row className="justify-content-center">

          <Col md={3} className='pt-3'>
            <GridTable 
              title={`Top Selling | ${shop?.shopName || "My Shop"}`}
              items={topSelling}
            />
          </Col>

          <Col md={3} className='pt-3'>
            <GridTable 
              title={`Big Discounts | ${shop?.shopName || "My Shop"}`}
              items={discountProducts}
            />
          </Col>

          <Col md={3} className='pt-3'>
            <GridTable 
              title={`Budget Deals | ${shop?.shopName || "My Shop"}`}
              items={lowPriceProducts}
            />
          </Col>

          <Col md={3} className='pt-3'>
            <GridTable 
              title={`New Arrivals | ${shop?.shopName || "My Shop"}`}
              items={newArrival}
            />
          </Col>

        </Row>
      </Container>

      <TopSelling products={topSelling} />

      <Container className="pb-5"></Container>

      <NewArrival products={newArrival} />

      <Container className="pb-5"></Container>
      
    </>
  )
}

export default MainPage;
